module.exports = "/_next/static/images/hologram-9423c7e99cb61ef0209a683cfb4c95f8.svg";